<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow': control.elementVal.getValue()?.duringChange === 't' }"></div>
    <img class="control__img border-light"
         [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style bg-style__icon': control.elementVal.getValue()?.duringChange !== 't' }"
         ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId)}}"
         width="72" height="72" alt="" />
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style bg-style__label': control.elementVal.getValue()?.duringChange !== 't' }">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>

    <div class="control__content">
        <div class="control__range">
            <div class="control__value font-55 font-bold"
                 [ngClass]="control.setColorByCompany()">
                 {{ control.elementVal.getValue()?.params.value | format
                    :control.elementVal.getValue()?.params.format
                    :control.elementVal.getValue()?.params.txtId
                    :control.elementVal.getValue()?.params.jump }}
            </div>
            <div class="control__min color-basic font-14">
                <p>
                    <span>{{ subtitle(395) + ' ' }}</span>
                    <span>{{ control.elementVal.getValue()?.params.min | format
                        :control.elementVal.getValue()?.params.format
                        :control.elementVal.getValue()?.params.txtId
                        :control.elementVal.getValue()?.params.jump }}</span>
                </p>
            </div>
            <div class="control__max color-basic font-14">
                <p>
                    <span>{{ subtitle(1064) + ' ' }}</span>
                    <span>{{ control.elementVal.getValue()?.params.max | format
                        :control.elementVal.getValue()?.params.format
                        :control.elementVal.getValue()?.params.txtId
                        :control.elementVal.getValue()?.params.jump }}
                    </span>
                </p>
            </div>
            <input class="control__input-range cursor-pointer"
                   type="range"
                   step="1"
                   min="{{ control.elementVal.getValue()?.params.min }}"
                   max="{{ control.elementVal.getValue()?.params.max }}"
                   value="{{ control.elementVal.getValue()?.params.value }}"
                   [(ngModel)]="control.elementVal.getValue()?.params.value" />
            <div class="control__remove cursor-pointer">
                <hold-wrapper (onAction)="control.reduceVal()">
                    <img ngSrc="/assets/img/icons/minus.svg"
                         width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
            <div class="control__add cursor-pointer">
                <hold-wrapper (onAction)="control.increaseVal()">
                    <img ngSrc="/assets/img/icons/plus.svg"
                         width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
        </div>
    </div>

    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
                data-testid="goBackButton"
                (click)="control.hideControl()">
            <img class="control__button-img"
                 ngSrc="/assets/img/zone_icons/back.svg"
                 width="40" height="40" alt="" />
        </button>
        <button class="control__button control__button--small bg-default"
                data-testid="resetButton"
                (click)="resetValue()">
            <img class="control__button-img"
                 ngSrc="/assets/img/icons/return.svg"
                 width="40" height="40" alt="" />
        </button>
        <button class="control__button"
               data-testid="sendButton"
               [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                    'bg-ok bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                (click)="control.returnVal(control.elementVal.getValue()?.params.value)">
            <img class="control__button-img"
                 ngSrc="/assets/img/icons/ok.svg"
                 width="40" height="40" alt="" />
        </button>
    </div>

    <div *ngIf="control.elementVal.getValue()?.duringChange === 't'"
         class="control__during-change">
        <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
    </div>
</div>
